import { useEffect, useRef } from "react";

import { LazyImage } from "@/src/components/common/lazy-image/LazyImage";

import { Ga4WithEventParameters } from "@/src/helpers/google-tag-manager/events/ga4-with-eventparameters";

import styles from "./styles.module.css";

const clickUrl =
  "https://www.akbank.com/basvuru/konut-kredisi/?cid=emlkjt1&utm_source=emlakjet&utm_medium=konutkredi&utm_campaign=emlakjet&utm_term=sabitbanner";

const impressionUrl =
  "https://track.adform.net/adfserve/?bn=80920429;1x1inv=1;srctype=3;gdpr=$%7Bgdpr%7D;gdpr_consent=$%7Bgdpr_consent_50%7D;ord=%5Btimestamp%5D";

const AkbankBanner = () => {
  const bannerRef = useRef(null);
  const impressionSent = useRef(false);

  useEffect(() => {
    if (!bannerRef.current) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !impressionSent.current) {
          impressionSent.current = true;
          fetch(impressionUrl, { method: "GET", mode: "no-cors" });
          observer.disconnect();
        }
      },
      { threshold: 0.5 }
    );

    observer.observe(bannerRef.current);

    return () => observer.disconnect();
  }, []);

  const handleBannerClick = () => {
    Ga4WithEventParameters({ eventName: "ilan_banner", eventParameters: { widget: "akbank_konut_kredi" } });
  };

  return (
    <div ref={bannerRef} className={styles.bannerContainer}>
      <a
        href={clickUrl}
        target="_blank"
        rel="noopener noreferrer nofollow"
        className={styles.link}
        onClick={handleBannerClick}
      >
        <LazyImage
          src="/assets/images/akbank-dekstopBanner.jpg"
          loading="lazy"
          alt="akbank reklam görseli"
          width="100%"
        />
      </a>
    </div>
  );
};

export default AkbankBanner;
